export enum DeliveryStatusEnum {
    Unknow = 0,
    Rejected = 2,
    Delivered = 3,
    Expired = 4,
    Undeliverable = 6,
    WaitingStatusConfirmation = 99
}